import { defineStore } from 'pinia'
import http from './http'
import { Response } from '@/types'
import { useMenuStore } from './menu'
import { useAuthStore } from '@/plugins'
import { useLoadingStore } from './loading'
import { useResetStore } from '@/utils/useResetStore'

// export interface Profile {
//   account: Account;
//   permissions: string[];
//   role: string;
// }
// export interface Account {
//   username: string;
//   avatar: string;
//   gender: number;
// }
export interface UserInfo {
  id: number
  username: string
  password: string
  icon: string
  email: string
  nickName: string
  note: string
  createTime: string
  loginTime: string
  status: number
  phone: string
  qqNumber: string | null
  wechat: string
  gender: number
  birthday: string | null
  adminRoleList: any[]
  permissionKeyList: any[]

  ifPlayer: number
  authId?: number
  authRealName?: string
  authIdCardNo?: string
  authPhone?: string
  authWechat?: string
  authLocation?: string
  authAlipay?: string

  // 收款码
  wechatQrcodeUrl?: string
  alipayQrcodeUrl?: string
}

export interface AuthInfo {
  authId?: number
  authRealName: string
  authIdCardNo: string
  authPhone: string
  authWechat: string
  authLocation: string
  authAlipay: string
}

export type TokenResult = {
  token: string
  tokenHead: string
}
export const useAccountStore = defineStore('account', {
  state() {
    return {
      // account: {} as Account,
      userInfo: {} as UserInfo,
      authInfo: {} as AuthInfo,
      wallet: null,
      permissions: [] as string[],
      roles: [],
      logged: false
    }
  },
  actions: {
    async login(username: string, password: string) {
      return http
        .request<TokenResult, Response<any>>('/admin/login', 'post_json', { username, password })
        .then(async (response) => {
          if (response.code === 200) {
            const { tokenHead, token } = response.data
            this.logged = true
            http.setAuthorization(tokenHead + token)
            await useMenuStore().getMenuList()
            return response.data
          } else {
            return Promise.reject(response)
          }
        })
    },
    async logout() {
      return http.request<any, Response<any>>('/admin/logout', 'post_json').then((response) => {
        localStorage.removeItem('stepin-menu')
        // useMenuStore().$reset();
        // const resetStore = useResetStore();
        // resetStore.menu();
        http.removeAuthorization()
        this.logged = false
        return response
      })
      // return new Promise<boolean>((resolve) => {

      //   localStorage.removeItem('stepin-menu');
      //   http.removeAuthorization();
      //   this.logged = false;
      //   resolve(true);
      // });
    },
    async profile() {
      const { setAuthLoading } = useLoadingStore()
      setAuthLoading(true)
      return http
        .request<any, Response<any>>('/admin/self', 'get')
        .then((response) => {
          if (response.code === 200) {
            const { setAuthorities } = useAuthStore()
            const { adminRoleList } = response.data
            this.userInfo = response.data
            this.roles = adminRoleList.map((item) => item.keyName)
            setAuthorities(response.data.permissionKeyList)
            return response.data
          } else {
            return Promise.reject(response)
          }
        })
        .finally(() => setAuthLoading(false))
    },
    async updateProfile(payload: any) {
      const { setAuthLoading } = useLoadingStore()
      setAuthLoading(true)
      let params = {
        id: this.userInfo.id,
        ...payload
      }
      return http
        .request<any, Response<any>>('/admin/update', 'POST_JSON', params)
        .then((response) => {
          if (response.code === 200) {
            this.profile()
            return response.data
          } else {
            return Promise.reject(response)
          }
        })
        .finally(() => setAuthLoading(false))
    },
    async getAuthInfo() {
      return http.request<any, Response<any>>('/player-auth/info', 'GET').then((response) => {
        if (response.code === 200) {
          this.authInfo = response.data
          return response.data
        } else {
          return Promise.reject(response)
        }
      })
    },
    async updateAuthInfo(payload: any) {
      const params = {
        authId: this.authInfo.authId,
        ...payload
      }
      return http.request<any, Response<any>>('/player-auth/update', 'POST_JSON', params).then((response) => {
        if (response.code === 200) {
          this.getAuthInfo()
          return response.data
        } else {
          return Promise.reject(response)
        }
      })
    },
    async getWallet() {
      return http
        .request<any, Response<any>>('/player-wallet/detail', 'get')
        .then((response) => {
          if (response.code === 200) {
            this.wallet = response.data
            this.wallet.balanceAll = response.data.balanceAll / 100
            this.wallet.balanceCanWithdraw = response.data.balanceCanWithdraw / 100
            return response.data
          } else {
            return Promise.reject(response)
          }
        })
        .finally(() => {})
    },
    setLogged(logged: boolean) {
      this.logged = logged
    }
  }
})
